import React, { memo } from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';

const TableBodyStk = ({
    serialNumber,
    id,
    stkId,
    stkBarcode,
    itemId,
    itemNm,
    size,
    color,
    qty,
    bqty,
    sqty,
    disrate,
    disamt,
    srate,
    schlId,
    schlcd,
    schlNm,
    schlinfo,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/SalePurchaseEdit/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to delete this Item?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            // dispatch(deleteSingleParty(id))
            //     .then(() => {
            //         // Reload the page to show updated results
            //         toast("Cloth Deleted Sucessfully");
            //         window.location.reload();
            //     })
            //     .catch((error) => {
            //         // Handle any errors that occur during the deletion process
            //         console.error("Error deleting Item:", error);
            //         toast.error("Failed to delete Item");
            //     });
        }
    };

    let schlnm;

    if (Array.isArray(schlinfo)) {
        schlnm = schlinfo.map((item, index) => (
            <span key={index}>
                {item.schlNm}
                <span style={{ color: 'blue' }}>-{item.schlcd}</span>
            </span>
        ));
    } else if (schlinfo) {
        const splitval = schlinfo?.split('-');
        schlnm = (
            <span>
                {splitval[0]}
                <span style={{ color: 'blue' }}>- {splitval[1]}</span>
          
            </span>
        );
    }



    console.log(schlinfo)
    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {serialNumber}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {schlnm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {itemNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {size}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {qty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {sqty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {bqty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {disrate}
                </TableCell>


                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {disamt}
                </TableCell>*/}
            </TableRow>
        </>
    );
};

export default TableBodyStk;
